import { useTheme } from "@chakra-ui/react"

export default useTheme